// Guide del modulo Hotel — testi chiari in italiano per il tenant.
// Usate dal pulsante "?" (HelpButton) presente su ogni pagina e dalla sezione "Guida".

export const HOTEL_GUIDES = {
  camere: {
    title: 'Camere',
    intro: 'Qui crei e gestisci le camere della tua struttura: dati, prezzi, servizi e foto.',
    sections: [
      { h: 'A cosa serve', p: 'Ogni camera è la base di prenotazioni, calendario e prezzi. Senza almeno una camera non puoi ricevere prenotazioni.' },
      { h: 'Come si usa', p: 'Premi “Nuova camera”, compila i 7 pannelli (generale, capacità, letti, prezzi, pricing dinamico, policy, servizi) e collega le foto dalla Galleria.' },
      { h: 'Prezzi', p: 'Il prezzo base e le regole di pricing dinamico alimentano automaticamente il motore prezzi usato in prenotazioni e checkout.' },
      { h: 'Consiglio', p: 'Attiva una camera solo quando è completa: le camere attive compaiono nella pagina pubblica e nell’anteprima.' },
    ],
  },
  anteprima: {
    title: 'Anteprima camera',
    intro: 'Vedi come appare una camera al pubblico, con dati reali e prezzo calcolato.',
    sections: [
      { h: 'A cosa serve', p: 'Controlli l’aspetto finale della scheda camera prima di pubblicarla, senza uscire dal gestionale.' },
      { h: 'Aggiornamento in tempo reale', p: 'Se modifichi la camera in un’altra scheda, l’anteprima si aggiorna da sola.' },
      { h: 'Apri online', p: 'Il pulsante “Apri online” apre la vera pagina pubblica della camera.' },
    ],
  },
  vetrina: {
    title: 'Vetrina',
    intro: 'La pagina pubblica della tua struttura (mini-landing): storia, immagini, camere e mappa.',
    sections: [
      { h: 'A cosa serve', p: 'È la prima pagina che vede il cliente quando apre la tua struttura da /alloggi, prima delle singole camere.' },
      { h: 'Contenuti', p: 'Imposti sottotitolo, storia e immagini generali (scelte dalla tua Galleria). Le camere attive e i punti di interesse compaiono in automatico.' },
      { h: 'Pubblica', p: 'Con l’interruttore “Pubblica vetrina” la struttura appare nell’elenco pubblico Alloggi. Da bozza resta visibile solo a te in anteprima.' },
      { h: 'Anteprima', p: 'A destra vedi in tempo reale come apparirà la pagina. “Apri online” mostra la versione pubblica reale.' },
      { h: 'Dati collegati', p: 'Contatti, orari, coordinate (mappa) e punti di interesse si modificano in Impostazioni (Struttura e Mappe).' },
    ],
  },
  calendario: {
    title: 'Calendario',
    intro: 'Vista mensile di tutte le prenotazioni e i blocchi, per camera e per canale.',
    sections: [
      { h: 'A cosa serve', p: 'Vedi a colpo d’occhio le date occupate ed eviti sovrapposizioni. La disponibilità è sempre verificata dal server.' },
      { h: 'Creare e bloccare', p: 'Clicca su un giorno per creare una prenotazione oppure per bloccare le date (es. manutenzione).' },
      { h: 'Colori e fonti', p: 'Ogni prenotazione mostra fonte (manuale, Booking, Airbnb…) e stato (in attesa, confermata, ecc.).' },
      { h: 'Sincronizzazione', p: 'Con la sincronizzazione iCal (in Impostazioni) i calendari dei canali restano allineati e riduci il rischio di overbooking.' },
    ],
  },
  prenotazioni: {
    title: 'Prenotazioni',
    intro: 'Elenco e dettaglio di tutte le prenotazioni, con azioni su ospite, pagamenti e messaggi.',
    sections: [
      { h: 'A cosa serve', p: 'Gestisci l’intero ciclo di vita: creazione, conferma, pagamento, cambio date, cancellazione, rimborso.' },
      { h: 'Scheda dettaglio', p: 'Apri una prenotazione per vedere Riepilogo, Ospite, Pagamenti, Servizi extra, Messaggi, Documenti e Self check-in.' },
      { h: 'Regole automatiche', p: 'Se in Operatività hai attivato la conferma automatica o il soggiorno minimo/massimo, vengono applicate qui alla creazione.' },
      { h: 'Tracciamento', p: 'Ogni azione importante (pagamento, rimborso, cambio date, cancellazione) viene registrata nell’Audit.' },
    ],
  },
  messaggi: {
    title: 'Messaggi Ospiti',
    intro: 'Una conversazione per ogni prenotazione: messaggi dell’ospite, della struttura e di sistema.',
    sections: [
      { h: 'A cosa serve', p: 'Tieni tutta la comunicazione con l’ospite in un unico posto, collegata alla prenotazione.' },
      { h: 'Invio', p: 'Scrivi un messaggio e, se vuoi, invialo anche via email (richiede Postmark configurato).' },
      { h: 'Non letti', p: 'I messaggi in ingresso dall’ospite risultano “da leggere” finché non li apri; puoi segnare tutto come letto.' },
      { h: 'WhatsApp', p: 'Il canale WhatsApp/Meta arriverà con le credenziali dedicate; per ora puoi simulare un messaggio ospite per provare il flusso.' },
    ],
  },
  'servizi-extra': {
    title: 'Servizi Extra',
    intro: 'Il catalogo dei servizi aggiuntivi (colazione, parcheggio, transfer…) proposti in prenotazione e checkout.',
    sections: [
      { h: 'A cosa serve', p: 'Aumenti il valore del soggiorno offrendo extra a pagamento con icona e ordine personalizzati.' },
      { h: 'Ordinamento', p: 'Riordina i servizi con le frecce: lo stesso ordine viene usato nel checkout.' },
      { h: 'Eliminazione protetta', p: 'Se un servizio è già stato usato in una prenotazione non può essere eliminato (per non alterare lo storico): disattivalo invece di cancellarlo.' },
    ],
  },
  profitto: {
    title: 'Profitto',
    intro: 'Indicatori economici del periodo: lordo, commissioni, netto, rimborsi e occupazione.',
    sections: [
      { h: 'A cosa serve', p: 'Capisci quanto stai guadagnando davvero, con calcoli fatti solo lato server (niente stime approssimative).' },
      { h: 'Periodi', p: 'Scegli settimana, mese, trimestre, anno o un intervallo personalizzato.' },
      { h: 'KPI', p: 'Trovi ADR (prezzo medio), RevPAR, occupazione, notti e numero prenotazioni, con trend mensile.' },
      { h: 'Commissioni', p: 'Le commissioni del provider (in Impostazioni) vengono sottratte per darti il netto realistico.' },
    ],
  },
  rimborsi: {
    title: 'Rimborsi',
    intro: 'Gestione completa dei rimborsi con anteprima, conferma esplicita e storico.',
    sections: [
      { h: 'A cosa serve', p: 'Emetti rimborsi in modo sicuro applicando la tua policy di cancellazione a scaglioni.' },
      { h: 'Anteprima poi conferma', p: 'L’anteprima calcola l’importo ma non muove denaro; solo la conferma esplicita esegue il rimborso.' },
      { h: 'Sicurezza', p: 'Ogni rimborso è idempotente (nessun doppio addebito) e tracciato nello storico e nell’Audit.' },
      { h: 'Nota', p: 'Il motore è SIMULATO finché non colleghi Stripe: la logica e i controlli restano identici.' },
    ],
  },
  'email-templates': {
    title: 'Email Templates',
    intro: 'Personalizzi le email automatiche: conferma, ricevuta, promemoria check-in e altre.',
    sections: [
      { h: 'A cosa serve', p: 'Comunichi con un tono coerente al tuo brand, riutilizzando testi pronti con segnaposto.' },
      { h: 'Segnaposto', p: 'Inserisci token come nome ospite, codice prenotazione, date: vengono sostituiti con i dati reali.' },
      { h: 'Anteprima', p: 'Vedi subito il risultato con dati dimostrativi; i segnaposto sconosciuti vengono segnalati.' },
      { h: 'Modalità avanzata', p: 'La modifica dell’HTML richiede la Modalità avanzata (permesso attivabile in Impostazioni).' },
    ],
  },
  checkout: {
    title: 'Checkout UI',
    intro: 'Configuri aspetto e testi delle pagine di prenotazione, ringraziamento e conferma.',
    sections: [
      { h: 'A cosa serve', p: 'Rendi il checkout coerente con il tuo brand (logo, colori, testi) e vedi un’anteprima realistica.' },
      { h: 'Modalità', p: 'Scegli pagamento immediato o garanzia: è la presentazione del flusso all’ospite.' },
      { h: 'CSS personalizzato', p: 'Disponibile solo in Modalità avanzata e sempre sanitizzato per sicurezza.' },
      { h: 'Nota', p: 'Questa sezione non esegue pagamenti: serve a configurare la presentazione.' },
    ],
  },
  pagamenti: {
    title: 'Pagamenti',
    intro: 'Mostra lo stato dell’integrazione dei pagamenti della tua struttura.',
    sections: [
      { h: 'A cosa serve', p: 'Verifichi se i pagamenti sono attivi, se la configurazione è completa e quali modalità sono disponibili.' },
      { h: 'Sicurezza', p: 'Le chiavi segrete non vengono mai mostrate nel gestionale.' },
      { h: 'Attivazione', p: 'Il collegamento reale a Stripe verrà abilitato con le credenziali dedicate. Trovi questo pannello anche in Impostazioni → Pagamenti.' },
    ],
  },
  impostazioni: {
    title: 'Impostazioni',
    intro: 'Il centro di controllo della tua struttura: dati, regole operative, calendari, self check-in, privacy, mappe, pagamenti, automazioni e audit.',
    sections: [
      { h: 'Struttura', p: 'Nome, contatti, indirizzo, coordinate, orari e fuso orario. Usati in email e checkout.' },
      { h: 'Operatività', p: 'Apertura prenotazioni, conferma automatica, orari check-in/out, soggiorno minimo/massimo, deposito predefinito.' },
      { h: 'Calendari', p: 'Importa i calendari dei canali (Booking, Airbnb, Google) ed esporta il tuo per evitare overbooking.' },
      { h: 'Self check-in', p: 'Istruzioni e codice di accesso. Il codice è sensibile: salvato in modo sicuro e mostrato mascherato; visibile all’ospite solo nel periodo corretto.' },
      { h: 'Documenti e privacy', p: 'Giorni di conservazione, accesso protetto, eliminazione programmata e tracciamento della visione amministrativa.' },
      { h: 'Mappe e concierge', p: 'Coordinate, chiave mappe (sensibile, mascherata), raggio di ricerca e punti di interesse per l’area ospite.' },
      { h: 'Pagamenti', p: 'Solo lo stato dell’integrazione: attiva/inattiva, configurata/incompleta, modalità disponibili.' },
      { h: 'Automazioni', p: 'Colleghi eventi (nuova prenotazione, pagamento, promemoria, cancellazione, rimborso, messaggio, documento) ad azioni (notifica, messaggio di sistema, email, aggiornamento CRM). Le esecuzioni sono idempotenti.' },
      { h: 'Audit', p: 'Registro in sola lettura di tutte le operazioni importanti, per piena trasparenza.' },
    ],
  },
  guida: {
    title: 'Guida',
    intro: 'Tutte le guide del modulo Hotel in un unico posto.',
    sections: [
      { h: 'Come funziona', p: 'Trovi la spiegazione di ogni pagina. Ovunque nel gestionale puoi anche premere il pulsante “?” in alto a destra per aprire la guida della pagina in cui ti trovi.' },
    ],
  },
};

export const HOTEL_GUIDE_ORDER = [
  'camere', 'anteprima', 'vetrina', 'calendario', 'prenotazioni', 'messaggi', 'servizi-extra',
  'profitto', 'rimborsi', 'email-templates', 'checkout', 'pagamenti', 'impostazioni',
];
